export default __webpack_public_path__ + "static/media/team_lead.60680616.png";